module.exports = __webpack_public_path__ + "img/featuredartist (8).0b6dfa8d.jpg";